import type {ReactElement} from 'react';
import styles from './ai-chat-footer.module.scss';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';

export function AiChatFooter(): ReactElement | null {
  const {state} = useAiChat();

  if (!state.hasMessages && !state.isQuickTipsView && !state.isAssetsView) {
    return null;
  }

  return <div className={styles.aiChatFooter} />;
}
